import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { createBrowserHistory } from "history";
import MomentUtils from "@date-io/moment";
import { Provider as StoreProvider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@material-ui/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { theme } from "./common/theme";
import { configureStore } from "./store";
import routes from "./routes";
import { CookiesNotification, ScrollReset, StylesProvider } from "./components";
import SessionManager from "./components/SessionManager/index";
import { LeftMenuProvider } from "src/common/Storage/LeftMenu.Context";
import "simplebar/src/simplebar.css";
import "./assets/scss/bootstrap.css";
import "./assets/scss/main.css";
import "./assets/scss/custom.css";
import Button from "@material-ui/core/Button";
import GenerateAi from "./screens/GenerateAi/GenerateAi";

const history = createBrowserHistory();
const store = configureStore();

function App() {
  const notistackRef = React.createRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };
  return (
    <StoreProvider store={store}>
      <SnackbarProvider
        maxSnack={3}
        ref={notistackRef}
        action={(key) => <Button onClick={onClickDismiss(key)}>Close</Button>}
      >
        <ThemeProvider theme={theme}>
          <LeftMenuProvider>
            <StylesProvider direction={"ltr"}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Router history={history}>
                  <Switch>
                    <Route exact path="/GenerateAi" render={() => <><GenerateAi /><SessionManager /></>} />
                    <Route path="/">
                      <ScrollReset />
                      <CookiesNotification />
                      {renderRoutes(routes)}
                      <SessionManager />
                    </Route>
                  </Switch>
                </Router>
              </MuiPickersUtilsProvider>
            </StylesProvider>
          </LeftMenuProvider>
        </ThemeProvider>
      </SnackbarProvider>
    </StoreProvider>
  );
}

export default App;
